import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormInput, dateFormatDateTime, comma } from "@/utils";
import { useGetNotificationListQuery } from "@/redux/notificationApi";

// 1) getMyInfo 훅 임포트
import { useGetMyInfoQuery } from "@/redux/memberApi";
import { setMyInfo } from "@/redux/slice/myInfoSlice";

// 아이콘 등
import alertIcon from "@/assets/icons/notifications_wh.svg";
import starIcon from "@/assets/icons/star-wh.svg";

const Header = ({ setAlertModal }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { data: myInfoResponse, isLoading: isMyInfoLoading, isError: isMyInfoError, error: myInfoError } = useGetMyInfoQuery();

    const { formData, handleChange, setFormData } = useFormInput({
        noticePopupStatus: false,
    });
    const { noticePopupStatus } = formData;

    useEffect(() => {
        let token = localStorage.getItem("access_token");
        if (!token) navigate("/login");

        if (!isMyInfoLoading && myInfoResponse) {
            dispatch(setMyInfo(myInfoResponse.data.member));

            if (myInfoResponse?.data.rentCorps[0]?.initInfoSaveYn !== undefined) {
                if (myInfoResponse?.data.rentCorps[0]?.initInfoSaveYn === "N") {
                    navigate("/tutorial");
                }
            }
        }
    }, [navigate, myInfoResponse, isMyInfoLoading, dispatch]);

    const handleLogout = () => {
        // Chart.js tooltip DOM 제거 (id 기반)
        const chartTooltip = document.getElementById("chartjs-tooltip");
        if (chartTooltip) chartTooltip.remove();

        localStorage.removeItem("access_token");
        localStorage.clear();
        dispatch({ type: "LOGOUT" });
        navigate("/login");
    };

    const memberData = myInfoResponse?.data;

    return (
        <>
            <header>
                <div className="header">
                    <div className="header-user">
                        <div className="user-name">
                            {!isMyInfoLoading && memberData && (
                                <span>
                                    <em>
                                        <b>{memberData?.member?.name || ""}</b>
                                    </em>
                                    님, 환영합니다.
                                </span>
                            )}
                            {!isMyInfoLoading && !memberData && <span>게스트님, 환영합니다.</span>}
                        </div>
                        <ul className="user-info">
                            <li>
                                <span>
                                    회원ID <b>{memberData?.member?.loginId || "----"}</b>
                                </span>
                            </li>
                            <li>
                                <span>
                                    마일리지 <b>{comma(memberData?.member?.mileage) || "0"}</b>M
                                </span>
                            </li>
                            {/* <li>
                                <span>
                                    포인트 <b>{memberData?.member?.point || "0"}</b>P
                                </span>
                            </li> */}
                        </ul>
                    </div>
                    <div className="header-info">
                        <ul className="info-nav">
                            <li>
                                <a
                                    onClick={() =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            noticePopupStatus: true,
                                        }))
                                    }
                                >
                                    <img src={alertIcon} alt="" />
                                </a>
                            </li>
                            {/* <li>
                                <a>
                                    <img src={starIcon} alt="" />
                                </a>
                            </li> */}
                        </ul>
                        <div className="logout">
                            <button type="button" onClick={handleLogout}>
                                로그아웃
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {noticePopupStatus && (
                <NoticePopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, noticePopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

// 알림/공지사항
const NoticePopup = ({ layer = true, onClose, formData, setFormData }) => {
    const navigate = useNavigate();
    const { data: notificationsData, isLoading, error } = useGetNotificationListQuery();

    const notifications = notificationsData?.data || [];

    const handleItemClick = (notification) => {
        // entityType에 따라 다른 경로 이동
        if (notification.entityType === "ORDER") {
            navigate(`/order/manage/${notification.entityId}`);
        } else if (notification.entityType === "CONTRACT") {
            navigate(`/contract/status/${notification.entityId}`);
        }
        // 팝업 닫기
        onClose();
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup reserve-status-popup">
                <div className="popup-header">
                    <h2>알림</h2>
                    <button className="btn-close" onClick={onClose}></button>
                </div>
                <div className="popup-content">
                    <div className="content-list">
                        {notifications.length === 0 && <div className="empty-notification">알림이 없습니다.</div>}
                        {notifications.map((notification) => (
                            <div
                                key={notification.id}
                                className={`item ${notification.readYn === "Y" ? "read" : "unread"}`}
                                // onClick={() => handleItemClick(notification)}
                            >
                                <div className="item-info">
                                    <div className="info-member">
                                        <span className="member-name">{notification.title}</span>
                                        <span className="member-phone">{dateFormatDateTime(notification.createdAt, "YYYY-MM-DD")}</span>
                                    </div>
                                    <div className="info-detail">
                                        <div className="detail-reserved_at">{notification.midTitle}</div>
                                        <span className="detail-reserved_type">{notification.content}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <div className="item">
                            <div className="item-info">
                                <div className="info-member">
                                    <span className="member-name">보험대차</span>
                                    <span className="member-phone">2025-02-05</span>
                                </div>
                                <div className="info-detail">
                                    <div className="detail-reserved_at">
                                        <span>250124172401</span>
                                        <span>경기 하남시</span>
                                    </div>
                                    <span className="detail-reserved_type">요청하신 보험대차를 회원번호 00157 이 배정 받았습니다.</span>
                                </div>
                            </div>
                            <div className="btn-list">
                                <button type="button" className="btn-cell btn-gray">
                                    거절
                                </button>
                                <button type="button" className="btn-cell btn-outline">
                                    수락
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="popup-bottom">
                    <button
                        className="btn btn-primary btn-confirm"
                        onClick={() => {
                            navigate("/admin/notification");
                            onClose();
                        }}
                    >
                        전체 보기
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};

export default Header;
